// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Xx","title":"e_Yx","hiddenMobile":"e_Zx"};